<template>
    <div>
        <div>
            <b-field label="First Name">
                <b-input v-model="newUser.firstName"></b-input>
            </b-field>
            <b-field label="Last Name">
                <b-input v-model="newUser.lastName"></b-input>
            </b-field>
            <b-field label="Username AD" v-show="isEnabledUsernameAD()">
                <b-input v-model="newUser.usernameAD"></b-input>
            </b-field>
            <b-field label="Email">
                <b-input type="email" v-model="newUser.email"></b-input>
            </b-field>
            <b-field label="Password" v-show="isEnabledOnlyExternal()">
                <b-input type="password" v-model="newUser.password" password-reveal></b-input>
            </b-field>
        </div>
        <div class="media-content--user">
            <h5 class="subtitle is-5 is-spaced">Roles</h5>
            <div class="columns">
                <div class="column">
                    <section>
                        <div class="field">
                            <b-radio v-model="newUser.idRole" native-value="1">Admin</b-radio>
                        </div>
                        <div class="field">
                            <b-radio v-model="newUser.idRole" native-value="2" type="is-succes">Operator</b-radio>
                        </div>
                    </section>
                </div>
                <div class="column">
                    <section>
                        <div class="field">
                            <b-radio v-model="newUser.idRole" native-value="3" type="is-warning">Viewer</b-radio>
                        </div>
                        <div class="field">
                            <b-radio v-model="newUser.idRole" native-value="4" type="is-danger">External</b-radio>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CreateUser',
        data() {
            return {
                newUser: {
                    firstName: '',
                    lastName: '',
                    usernameAD: '',
                    email: '',
                    password: '',
                    idRole: '4' //Externo
                },
            }
        },
        mounted() {
            this.$emit('newUser', this.newUser)
        },
        methods:
        {
            isEnabledUsernameAD: function () {
                if (this.newUser.idRole == '4') {
                    this.newUser.usernameAD = '';
                    return false;
                } 

                return true;
            },
            isEnabledOnlyExternal: function (){
                const newUser = this.newUser;
                if (newUser.idRole == '1' || newUser.idRole == '2' || newUser.idRole == '3') {
                    newUser.password = '';
                    return false;
                }
                return true;
            }
        },
            
    }
</script>